import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function SaveChangesModal({ changedInfo }) {
  return (
    <Box>
      <Text textAlign="center">
        {`The changes you have made to the ${changedInfo} have not yet been saved.` }
      </Text>
    </Box>
  );
}

SaveChangesModal.propTypes = {
  /** Description of info that has been updated */
  changedInfo: PropTypes.string
};

export default SaveChangesModal;
